import apiClient from './apiClient';
import { PUT_EXCHANGE_RATE_URL } from './apiUrl';

const putExchangeRateApi = (Id, data) => {
  return apiClient.put(PUT_EXCHANGE_RATE_URL(Id), data);
};

export default putExchangeRateApi;
